import { DEFAULT_LOCALE, isSupportedLocale } from "../i18n/locales.js";
import { routeSectionSlugs } from "../data/navigation.js";

export function normalizeLocale(lang) {
  return isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;
}

export function resolveRoute(lang = DEFAULT_LOCALE, sectionKey = "home", params = {}) {
  const locale = normalizeLocale(lang);

  if (sectionKey === "home") {
    return `/${locale}/`;
  }

  if (sectionKey === "university") {
    return "/university/";
  }

  const section = routeSectionSlugs[sectionKey];
  if (!section) {
    throw new Error(`Unknown route section: ${sectionKey}`);
  }

  const sectionPath = `/${locale}/${section[locale]}`;
  const itemSlug = params.slug || params.programSlug || params.courseSlug || params.eventSlug || params.articleSlug || params.downloadSlug;

  if (sectionKey === "programs" && params.programSlug && params.seasonSlug) {
    return `${sectionPath}/${params.programSlug}/${params.seasonSlug}`;
  }

  if (itemSlug) {
    return `${sectionPath}/${itemSlug}`;
  }

  return sectionPath;
}

export function getSectionKeyFromSlug(lang, slug) {
  const locale = normalizeLocale(lang);
  return Object.entries(routeSectionSlugs).find(([, slugs]) => slugs[locale] === slug)?.[0];
}
